import * as tslib_1 from "tslib";
/* I69 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Change = /** @class */ (function (_super) {
    tslib_1.__extends(Change, _super);
    function Change() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Change.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M14,15 L17.25,14.917 C16.227,16.727 13.877,17.881 11.778,17.881 C8.601,17.881 6.016,15 6.016,12 L5.016,12 C5.016,16 8.049,18.881 11.778,18.881 C15.833,18.881 18,15.667 18,15.667 L18,19 L19,19 L19,14 L14,14 L14,15 Z M10,9 L6.758,9.083 C7.781,7.273 10.135,6.119 12.234,6.119 C15.411,6.119 18,9 18,12 L19,12 C19,8 15.959,5.119 12.23,5.119 C8.175,5.119 6,8.333 6,8.333 L6,5 L5,5 L5,10 L10,10 L10,9 Z" })))));
    };
    return Change;
}(React.Component));
export { Change };
export default Change;
//# sourceMappingURL=Change.js.map